module.exports = __webpack_public_path__ + "static/upkeeping-a4f65f173b7729447a18a3836f7028bb.jpg";